/**
 * @description 项目组其他配置变量
 */
module.exports = {
  // 是否开启登录RSA加密
  loginRSA: false,
  // 加密密匙
  publicKey: 'Ecode,123:Ecode1',
  // 默认登录key
  clientKey: 'H5',
  // 客户端类型:H5,DINGTALK,MP,MA,CP
  appType: 'mp',
  // 文件预览地址，不配置不启用
  kkViewUrl: '',
  // 项目路径
  apiBaseUrl: '',
  // 路由进度条展示
  enableRouterProgress: false,
  // 点击路由时设置标题栏标题
  enableSetRouterTitle: true,
  // 弹窗打开流程表单
  enableBpmnFormPopup: false

}
